import {Component, Input} from '@angular/core';
import {NavItem} from '@pt/pt-models';
import {PtCoreActions} from '@pt/pt-core';
import {Store} from '@ngrx/store';

@Component({
  selector: 'pt-navbar-logo-item',
  template: `
    <a class='navbar-brand navbar-logo text-light'
       [ngClass]='item?.classCss'
       (click)='clickItem()'>
      <pt-icon *ngIf='item?.icon && item.icon?.key'
               [key]='item.icon.key'
               [size]="item.icon.size"
               [iconType]="item.icon.type"
      ></pt-icon>

      <ng-container *ngIf="(item?.image | async) as logo else DEFAULT_LOGO">
        <div class="navbar-log-img"
             [ngStyle]="{ 'background-image': 'url(' + logo + ')'}"
        ></div>
      </ng-container>

      <ng-template #DEFAULT_LOGO>
        <div class="navbar-log-img"
             [ngStyle]="{ 'background-image': 'url(assets/images/default-logo.png)'}"
        ></div>
      </ng-template>
    </a>
  `,
  styles: [`
    .navbar-logo {
      cursor: pointer;
      height: 55px;
      padding: 0;
      display: contents;
    }

    .navbar-logo * {
      cursor: pointer;
    }

    .navbar-log-img {
      /*height: 150px;*/
      height: 50px;
      width: 250px;
      /*max-width: 150px;*/
      /*min-width: 50px;*/
      background-position: left;
      background-repeat: no-repeat;
      /*background-size: auto 50px;*/
      background-size: contain;
      background-origin: content-box;
    }
  `]
})
export class NavbarLogoItemComponent {

  @Input() item: NavItem;

  constructor(private store: Store) {
  }

  clickItem() {
    if (this.item?.routerLink) {
      this.store.dispatch(PtCoreActions.navigateTo({
        route: [this.item?.routerLink],
        onBlankPage: this.item?.routerLinkOpt?.routerLinkBlank,
        external: this.item?.routerLinkOpt?.routerLinkExternal
      }));
    }
  }

}
